import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { SynthesisStatus } from "../Exports";
export var TranslationSynthesisEnd = /*#__PURE__*/function () {
  function TranslationSynthesisEnd(json) {
    _classCallCheck(this, TranslationSynthesisEnd);

    this.privSynthesisEnd = JSON.parse(json);
    this.privSynthesisEnd.SynthesisStatus = SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
  }

  _createClass(TranslationSynthesisEnd, [{
    key: "SynthesisStatus",
    get: function get() {
      return this.privSynthesisEnd.SynthesisStatus;
    }
  }, {
    key: "FailureReason",
    get: function get() {
      return this.privSynthesisEnd.FailureReason;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      return new TranslationSynthesisEnd(json);
    }
  }]);

  return TranslationSynthesisEnd;
}();